"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDpItemBubble = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var api_1 = require("../../../api");
exports.StyledDpItemBubble = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  ", ";\n  flex-direction: column;\n  font-weight: bold;\n  margin-right: ", " !important;\n  font-size: ", ";\n\n  .status-container {\n    height: 50px;\n    ", ";\n  }\n\n  .circle {\n    background-color: ", ";\n    border: ", " solid;\n    border-color: ", ";\n    ", ";\n    border-radius: ", ";\n    color: ", ";\n    cursor: pointer;\n    font-family: ", ";\n\n    &.core {\n      height: 40px;\n      width: 40px;\n\n      i {\n        font-size: ", ";\n      }\n    }\n\n    .icon-container {\n      ", ";\n    }\n\n    &.active {\n      border-color: ", ";\n\n      .icon-container {\n        background-color: ", ";\n        height: 88%;\n        width: 88%;\n        border-radius: ", ";\n        color: ", ";\n      }\n    }\n\n    &.branch {\n      height: 20px;\n      width: 20px;\n      position: relative;\n\n      &::before {\n        content: '';\n        width: ", ";\n        border-bottom: 2px solid ", ";\n        position: absolute;\n        right: 100%;\n        margin-right: 2px;\n      }\n\n      i {\n        font-size: ", ";\n      }\n    }\n  }\n"], ["\n  color: ", ";\n  ", ";\n  flex-direction: column;\n  font-weight: bold;\n  margin-right: ", " !important;\n  font-size: ", ";\n\n  .status-container {\n    height: 50px;\n    ", ";\n  }\n\n  .circle {\n    background-color: ", ";\n    border: ", " solid;\n    border-color: ", ";\n    ", ";\n    border-radius: ", ";\n    color: ", ";\n    cursor: pointer;\n    font-family: ", ";\n\n    &.core {\n      height: 40px;\n      width: 40px;\n\n      i {\n        font-size: ", ";\n      }\n    }\n\n    .icon-container {\n      ", ";\n    }\n\n    &.active {\n      border-color: ", ";\n\n      .icon-container {\n        background-color: ", ";\n        height: 88%;\n        width: 88%;\n        border-radius: ", ";\n        color: ", ";\n      }\n    }\n\n    &.branch {\n      height: 20px;\n      width: 20px;\n      position: relative;\n\n      &::before {\n        content: '';\n        width: ", ";\n        border-bottom: 2px solid ", ";\n        position: absolute;\n        right: 100%;\n        margin-right: 2px;\n      }\n\n      i {\n        font-size: ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.primary;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('both');
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x4;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.smd;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('both');
}, function (_a) {
    var Colors = _a.theme.Colors, status = _a.status;
    return status === api_1.ItemResponseStatus.NotScored ? Colors.Backgrounds.web : '';
}, function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.x2;
}, function (_a) {
    var Colors = _a.theme.Colors, status = _a.status;
    return status === api_1.ItemResponseStatus.Correct
        ? Colors.Curriculum.em.proficient
        : status === api_1.ItemResponseStatus.PartiallyCorrect
            ? Colors.warning
            : status === api_1.ItemResponseStatus.NotScored
                ? Colors.Typography.hint
                : Colors.danger;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('both');
}, function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.Radiuses.circle;
}, function (_a) {
    var Colors = _a.theme.Colors, status = _a.status;
    return status === api_1.ItemResponseStatus.NotScored ? Colors.Typography.hint : Colors.primary;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.quicksandFontFamily;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.xl;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('both');
}, function (_a) {
    var Colors = _a.theme.Colors, status = _a.status;
    return status === api_1.ItemResponseStatus.Correct
        ? Colors.Curriculum.em.proficient
        : status === api_1.ItemResponseStatus.PartiallyCorrect
            ? Colors.warning
            : status === api_1.ItemResponseStatus.NotScored
                ? Colors.Typography.hint
                : Colors.danger;
}, function (_a) {
    var Colors = _a.theme.Colors, status = _a.status;
    return status === api_1.ItemResponseStatus.Correct
        ? Colors.Curriculum.em.proficient
        : status === api_1.ItemResponseStatus.PartiallyCorrect
            ? Colors.warning
            : status === api_1.ItemResponseStatus.NotScored
                ? Colors.Typography.hint
                : Colors.danger;
}, function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.Radiuses.circle;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.white;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x4;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Backgrounds.subtle;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.smd;
});
var templateObject_1;
